<template>
  <div class="container">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item to="/ecologicalCooperation">合作伙伴</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :model="dataForm"
      :rules="rules"
      ref="dataFormRef"
      label-position="right"
      label-width="150px"
      :disabled="loading || disabled"
    >
      <div class="rf ac jsb">
        <div class="rf title">
          <div class="top-bg flex-shrink"></div>
          <div class="flex-shrink">基础信息</div>
          <div class="error tip" v-if="info && info.companyEmpowerId &&info.applyStatus==2">{{info.empowerRemarks}}</div>
        </div>
        <div v-if="info && info.companyEmpowerId ? true : false" class="flex-shrink status">
          <div class="info" v-if="info.applyStatus==1 ">
            <img src="../../../assets/img/ecologicalCooperation/ing.png" width="22px" height="22px" class="icon"/>
            <!-- <i class="el-icon-more"></i> -->
            审核中
          </div>
          <div class="error" v-else-if="info.applyStatus==2 ">
            <i class="el-icon-error icon"></i>
            不通过
          </div>
          <div class="success" v-else-if="info.applyStatus==3 && info.empowerStatus == 20 ">
            <i class="el-icon-success icon"></i>
            审核通过  已授权
          </div>
          <div class="error" v-else-if="info.applyStatus==3 && info.empowerStatus == 30 ">
            <i class="el-icon-error icon"></i>
            终止授权
          </div>
        </div>
      </div>
      <el-row  class="rol-height top-20" :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业名称：" prop="companyName">
            <el-input
              v-model.trim="dataForm.companyName"
              maxlength="50"
              clearable
              placeholder="请输入企业名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业简称：" prop="companyShortName">
            <el-input
              v-model.trim="dataForm.companyShortName"
              maxlength="50"
              clearable
              placeholder="请输入企业简称"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row  class="rol-height" :gutter="20">
        <el-col :span="12">
          <el-form-item label="统一社会信用代码："
                    prop="socialCreditCode">
            <el-input v-model="dataForm.socialCreditCode"
                      placeholder="请输入统一社会信用代码"
                      :maxlength="18"
                      clearable
                      oninput="value=value.replace(/[^A-Za-z0-9]/g,'')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业地址："
                        prop="provinceId">
            <el-select v-model="dataForm.provinceId"
                      style="width: 30%;float:left"
                      @change="changeProvince"
                      placeholder="省">
              <el-option v-for="item in provinceList"
                        :key="item.codeP"
                        :label="item.name"
                        :value="item.codeP">
              </el-option>
            </el-select>
            <el-select v-model="dataForm.cityId"
                      style="width: 30%;float:left;margin-left:5%"
                      @change="changeCity"
                      placeholder="市">
              <el-option v-for="item in cityList"
                        :key="item.codeC"
                        :label="item.name"
                        :value="item.codeC">
              </el-option>
            </el-select>
            <el-select v-model="dataForm.areaId"
                      style="width: 30%;float:left;margin-left:5%"
                      placeholder="区">
              <el-option v-for="item in areaList"
                        :key="item.codeA"
                        :label="item.name"
                        :value="item.codeA">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row  class="rol-height" :gutter="20">
        <el-col :span="12">
          <el-form-item label="法人代表："
                    prop="legaPerson">
            <el-input v-model="dataForm.legaPerson"
                      placeholder="请输入法人姓名"
                      :maxlength="4"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label=""
                    prop="address">
            <el-input v-model="dataForm.address"
                      placeholder="详细地址：如街道，道路，园区，门牌号等"
                      :maxlength="50"
                      clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row  class="rol-height" :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系电话："
                    prop="mobile">
            <el-input v-model="dataForm.mobile"
                      placeholder="请输入联系电话"
                      :maxlength="16"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属行业："
                    prop="industry">
            <el-cascader v-model="dataForm.industry"
                        :options="industryList"
                        collapse-tags
                        style="width: 100%"
                        clearable
                        :props="defaultParams"></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row  class="rol-height" :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业性质："
                    prop="nature">
            <el-select v-model="dataForm.nature"
                      placeholder="请选择企业性质">
              <el-option v-for="item in typeList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册资金："
                    prop="registeredCapital">
            <el-input v-model="dataForm.registeredCapital"
                      placeholder="请输入注册资金"
                      :maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="简介："
                    prop="synopsis">
            <el-input v-model="dataForm.synopsis"
                      type="textarea"
                      :autosize="{ minRows: 4}"
                      placeholder="请输入内容，如经营范围等，不超过500字"
                      :maxlength="500"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="title">
        <div class="top-bg"></div>
        <div>合作自评</div>
      </div>
      <el-table
        :data="dataList"
        stripe
        border
        size="mini"
        style="width: 100%; margin-top: 10px;margin: 20px 20px 0;">
        <el-table-column prop="evaluationItems"  label="评估项目" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="evaluationResults" label="评估结果(就评估项目展开说明)" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.evaluationResults"
                      :placeholder="scope.row.placeholder"
                      :disabled="loading || disabled"
                      :maxlength="100"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="top-20">
        <el-checkbox v-model="checked">同意  我确定所提供的全部信息，真实，准确，有效</el-checkbox>
      </div>
      <div class="text-center">
        <el-button type="primary"
                   @click="dataFormSubmitHandle()"
                   :loading="loading"
                   :disabled="disabled"
                   class="top-20">提交申请</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { phoneReg } from '@/utils/reg'
export default {
  data () {
    let that = this
    var validateProvinceId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择省'))
      } else if (!that.dataForm.cityId) {
        return callback(new Error('请选择市'))
      } else if (!that.dataForm.areaId) {
        return callback(new Error('请选择区'))
      } else {
        callback()
      }
    }
    return {
      checked: false,
      loading: false,
      disabled: false,
      dataForm: {
        companyName: '',
        companyShortName: '',
        socialCreditCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        legaPerson: '',
        address: '',
        mobile: '',
        industry: '',
        nature: '',
        registeredCapital: '',
        synopsis: ''
      },
      rules: {
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyShortName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        provinceId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validateProvinceId, trigger: ['blur', 'change'] }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: ['blur', 'change'] },
          {
            pattern: phoneReg,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change']
          }
        ],
        nature: [
          { required: true, message: this.$t('validate.required'), trigger: ['blur', 'change'] }
        ]
      },
      info: null,
      dataList: [
        {
          evaluationItems: '当前所处行业',
          placeholder: '填写业务涉及的主要行业',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：流程工业（可根据业务占比）<br>60-80分：离散制造（可根据业务占比）<br>0-60分：其他行业', // 评分标准参考（管理端用）
          sort: '1'
        },
        {
          evaluationItems: '原合作品牌',
          placeholder: '填写原合作品牌名称',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：艾默生、霍尼韦尔、横河<br>60-80分：西门子、ABB、施耐德、和利时<br>0-60分：其他品牌', // 评分标准参考（管理端用）
          sort: '2'
        },
        {
          evaluationItems: '合作品牌经营业绩',
          placeholder: '填写原先合作品牌最近三年的合作业绩规模',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '100分：近三年合作销售规模3000万以上<br>80-100分：近三年合作销售规模1500万以上<br>60-80分：近三年合作销售规模1000万以上<br>40-60分：近三年合作销售规模500万以上<br>0-40分：近三年合作销售规模200万-500万', // 评分标准参考（管理端用）
          sort: '3'
        },
        {
          evaluationItems: '优势行业',
          placeholder: '就优势行业进行说明',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：优势行业范围广，并且能与现有的渠道互补，占比>60%<br>60-80分：优势行业能有现有渠道互补，占比>50%<br>40-60分：有相对优势的行业，占比>40%<br>40-60分：近三年合作销售规模500万以上<br>0-40分：优势行业不是很明显', // 评分标准参考（管理端用）
          sort: '4'
        },
        {
          evaluationItems: '优势区域',
          placeholder: '就优势区域进行说明',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：优势区域为急需覆盖的区域，且覆盖区域地理范围广/区域市场占比居绝对优势，占比>60%<br>60-80分：优势区域为当前需要加强的区域，且覆盖区域较广/区域市场占比有优势，占比>50%<br>40-60分：有相对优势的行业，占比>40%<br>40-60分：近三年合作销售规模500万以上<br>0-40分：优势行业不是很明显', // 评分标准参考（管理端用）
          sort: '5'
        },
        {
          evaluationItems: '战略客户资源',
          placeholder: '就战略客户资源进行介绍说明',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：丰富的TOP100行业战略客户资源，占比>60%<br>60-80分：有部分TOP100战略客户资源或地区TOP5战略客户资源，占比>50%<br>40-60分：有当地战略客户资源，占比>40%<br>0-40分：无或仅有一些', // 评分标准参考（管理端用）
          sort: '6'
        },
        {
          evaluationItems: '销售人员数量',
          placeholder: '填写销售人员人数规模',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：10人以上<br>60-80分：6-8人<br>40-60分：4-6人<br>0-40分：0-4人', // 评分标准参考（管理端用）
          sort: '7'
        },
        {
          evaluationItems: '负责人行业经验',
          placeholder: '填写负责人的行业从业年限',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '100分：5年以上<br>80-100分：3年以上<br>40-60分：4-6人<br>0-40分：0-4人', // 评分标准参考（管理端用）
          sort: '8'
        },
        {
          evaluationItems: '对中控认可度',
          placeholder: '填写对中控的了解和认可情况',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：高度认可，中控合作业绩占比80%以上<br>60-80分：认可，但也有顾虑，中控合作业绩占比50%以上<br>40-60分：认可度一般<br>0-40分：不是很认可', // 评分标准参考（管理端用）
          sort: '9'
        },
        {
          evaluationItems: '工程实施能力',
          placeholder: '就工程实施能力进行介绍',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：可实施全部自签合同<br>60-80分：可实施常规项目<br>40-60分：有工程人员', // 评分标准参考（管理端用）
          sort: '10'
        },
        {
          evaluationItems: '中控相关业绩占比情况',
          placeholder: '填写现有业务中与中控有关的业绩占比情况',
          evaluationResults: '', // 评估结果（各个评估项目的结果）
          scoringStandardReference: '80-100分：中控空白<br>60-80分：中控占有率低于20%<br>40-60分：中控占有少部分辅助系统', // 评分标准参考（管理端用）
          sort: '11'
        }
      ],
      // 行业树 props
      defaultParams: {
        label: 'industryName',
        value: 'industryId',
        children: 'children'
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      industryList: [],
      typeList: [
        {
          name: '企业',
          value: '10'
        },
        {
          name: '政府/事业单位',
          value: '20'
        },
        {
          name: '个体工商户',
          value: '30'
        },
        {
          name: '其他',
          value: '90'
        }
      ]
    }
  },
  mounted () {
    this.getProvinceList()
    this.getIndustryList()
    this.getInfo()
  },
  methods: {
    getProvinceList () {
      this.$http.post('/help/sys/sysProvince/queryList', {}).then(({ data: res }) => {
        this.provinceList = res.data
      }).catch(() => { })
    },
    // 选择省
    changeProvince () {
      this.dataForm.cityId = ''
      this.dataForm.areaId = ''
      this.cityList = []
      this.areaList = []
      this.$http.post('/help/sys/sysCity/queryList', { codeP: this.dataForm.provinceId })
        .then(({ data: res }) => {
          this.cityList = res.data
        }).catch(() => { })
    },
    // 选择市
    changeCity () {
      this.dataForm.areaId = ''
      this.areaList = []
      this.$http.post('/help/sys/sysArea/queryList', { codeC: this.dataForm.cityId })
        .then(({ data: res }) => {
          this.areaList = res.data
        }).catch(() => { })
    },
    // 获取行业列表
    getIndustryList () {
      this.industryList = []
      this.$http.post('/help/user/sys/custIndustry/queryList', {}).then(({ data: res }) => {
        this.industryList = res.data
      }).catch(() => { })
    },
    getInfo () {
      this.disabled = false
      if (this.$store.state.user.defaultCompanyId) {
        this.$http.get(`/front/custCompanyEmpower/info/${this.$store.state.user.defaultCompanyId}`)
          .then(({ data: res }) => {
            console.log(res, 'getInfo')
            if (res.data) {
              this.checked = true
              this.info = res.data
              this.disabled = true
              if (res.data.applyStatus === '2') {
                this.disabled = false
              }
              Object.keys(this.dataForm).forEach(item => {
                this.dataForm[item] = res.data[item]
              })
              if (res.data.industry && res.data.industry.length) {
                this.dataForm.industry = res.data.industry[0]
              } else {
                this.dataForm.industry = ''
              }
              this.dataList = res.data.custCompanySelfSorceVoList.map((item, index) => {
                return {
                  evaluationItems: item.evaluationItems,
                  placeholder: this.dataList[index].placeholder,
                  evaluationResults: item.evaluationResults,
                  scoringStandardReference: item.scoringStandardReference || this.dataList[index].scoringStandardReference,
                  sort: item.sort || this.dataList[index].sort
                }
              })
              this.$http.post('/help/sys/sysCity/queryList', { codeP: this.dataForm.provinceId })
                .then(({ data: res }) => {
                  this.cityList = res.data
                }).catch(() => { })
              this.$http.post('/help/sys/sysArea/queryList', { codeC: this.dataForm.cityId })
                .then(({ data: res }) => {
                  this.areaList = res.data
                }).catch(() => { })
            } else {
              // 未申请过
              this.info = null
            }
          }).catch(() => { })
      } else {}
    },
    // 提交
    dataFormSubmitHandle () {
      if (!this.checked) {
        return this.$message.warning('请 同意 确认所填写信息真实')
      }
      this.$refs['dataFormRef'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.dataList.some(item => {
          return item.evaluationResults === ''
        })) {
          this.$message.warning('合作自评需要全部填写 ')
          return false
        }
        this.loading = true
        let url = `/front/custCompanyEmpower/saveCompanyEmpower`
        const params = {
          ...this.dataForm,
          industry: this.dataForm.industry.length ? [this.dataForm.industry] : [],
          selfSorceForms: this.dataList
        }
        if (this.info && this.info.companyId) {
          url = `/front/custCompanyEmpower/updateCompanyEmpower`
          params['companyId'] = this.info.companyId
        }
        this.$http.post(url, params)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success('提交成功')
            this.getInfo()
          }).finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding: 10px;
}
.title{
  margin-right: 10px;
  .top-bg{
    width: 14px;
    height: 27px;
    background: #3D8BD4;
    margin-right: 10px;
  }
  .tip {
    margin-left: 20px;
    font-size: 14px;
  }
  display: flex;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 25px;
}
.rol-height{
  line-height: 30px;
}
.status{
  font-size: 18px;
}
.icon{
  font-size: 22px;
  margin-right: 3px;
}
.info {
  color: #999999;
  line-height: 25px;
  display: flex;
  align-items: center;
}
.error {
  color: #FF0C0C;
  line-height: 25px;
  display: flex;
  align-items: center;
}
.success {
  color: #34C113;
  line-height: 25px;
  display: flex;
  align-items: center;
}
</style>
